const CATEGORIES_PARENT_CONFIG = {
  development: [
    {
      id: 29,
      name: 'trang phục',
      key: 'clothes',
    },
    {
      id: 13,
      name: 'phụ kiện',
      key: 'Accessories',
    },
    {
      id: 25,
      name: 'giày',
      key: 'Shoes - Sandal',
    },
  ],
  production: [
    {
      id: null,
      name: 'trang phục',
      key: 'trang phục',
    },
    {
      id: 39,
      name: 'phụ kiện',
      key: 'Accessories',
    },
    {
      id: 55,
      name: 'giày dép',
      key: 'Shoes - Sandal',
    },
    {
      id: 56,
      name: 'túi xách',
      key: 'Bag',
    },
  ],
};

const CATEGORIES_PARENT =
  CATEGORIES_PARENT_CONFIG[process.env.GATSBY_API_URL == 'https://api.rentzy.id.vn' ? 'development' : 'production'];

export default CATEGORIES_PARENT;
